import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public sendNotificationLoginEvent: EventEmitter<string> = new EventEmitter<string>();
  onNotifyEvent$ = new Subject<any>();
  constructor() {}

  sendNotification(message:any){
    this.sendNotificationLoginEvent.emit(message);
  }
}
